module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header-sticky",
    attrs: {
      "id": "sp-header"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "container-inner"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "col-6 col-sm-6 col-md-6 col-lg-2 ",
    attrs: {
      "id": "sp-logo"
    }
  }, [_c('div', {
    staticClass: "sp-column "
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "static/images/homepage_logo2.png",
      "alt": " AFRICAN - EUROPEAN NARRATIVES"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-6 col-md-6 col-lg-8 ",
    staticStyle: {
      "position": "static"
    },
    attrs: {
      "id": "sp-menu"
    }
  }, [_c('div', {
    staticClass: "sp-column "
  }, [_c('nav', {
    staticClass: "sp-megamenu-wrapper",
    attrs: {
      "role": "navigation"
    }
  }, [_c('a', {
    staticClass: "offcanvas-toggler-right",
    attrs: {
      "id": "offcanvas-toggler",
      "aria-label": "Navigation",
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true",
      "title": "Navigation"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sp-megamenu-parent menu-animation-fade-up d-none d-lg-block"
  }, [_c('li', {
    staticClass: "sp-menu-item"
  }, [_c('a', {
    attrs: {
      "href": "/en/"
    }
  }, [_vm._v("All Stories")])]), _vm._v(" "), _c('li', {
    staticClass: "sp-menu-item sp-has-child"
  }, [_c('a', {
    attrs: {
      "href": "/en/testimonies"
    }
  }, [_vm._v("Testimonies")]), _vm._v(" "), _c('div', {
    staticClass: "sp-dropdown sp-dropdown-main sp-menu-right",
    staticStyle: {
      "width": "240px"
    }
  }, [_c('div', {
    staticClass: "sp-dropdown-inner"
  }, [_c('ul', {
    staticClass: "sp-dropdown-items"
  }, [_c('li', {
    staticClass: "sp-menu-item"
  }), _vm._v(" "), _c('li', {
    staticClass: "sp-menu-item"
  }), _vm._v(" "), _c('li', {
    staticClass: "sp-menu-item"
  }), _vm._v(" "), _c('li', {
    staticClass: "sp-menu-item"
  }), _vm._v(" "), _c('li', {
    staticClass: "sp-menu-item"
  }), _vm._v(" "), _c('li', {
    staticClass: "sp-menu-item"
  }), _vm._v(" "), _c('li', {
    staticClass: "sp-menu-item"
  }), _vm._v(" "), _c('li', {
    staticClass: "sp-menu-item"
  }), _vm._v(" "), _c('li', {
    staticClass: "sp-menu-item"
  }), _vm._v(" "), _c('li', {
    staticClass: "sp-menu-item"
  })])])])]), _vm._v(" "), _c('li', {
    staticClass: "sp-menu-item"
  }, [_c('a', {
    attrs: {
      "href": "/en/about"
    }
  }, [_vm._v("About")])]), _vm._v(" "), _c('li', {
    staticClass: "sp-menu-item"
  }, [_c('a', {
    attrs: {
      "href": "/en/glossary"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('li', {
    staticClass: "sp-menu-item"
  }), _vm._v(" "), _c('li', {
    staticClass: "sp-menu-item current-item active"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 ",
    attrs: {
      "id": "sp-position2"
    }
  }, [_c('div', {
    staticClass: "sp-column "
  }, [_c('div', {
    staticClass: "sp-module  mod-search-fcsh"
  }, [_c('div', {
    staticClass: "sp-module-content"
  }, [_c('div', {
    staticClass: "custom mod-search-fcsh"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "/en/search"
    }
  }, [_c('img', {
    staticStyle: {
      "margin": "0 0 0 auto"
    },
    attrs: {
      "src": "static/images/icons/search2.png",
      "alt": ""
    }
  })])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-116ce5aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 161
// module chunks = 2